import { useCallback, useEffect, useRef } from 'react';

// Keep the dialog mounted (and focus trapped) until a pointer exit finishes.
export default function useViewerMotion(onClose, entrance) {
  const target = useRef(null);
  const animation = useRef(null);
  const entered = useRef(false); // Radix may reattach the ref when dialog content changes.
  const ref = useCallback(node => {
    animation.current?.cancel();
    target.current = node;
    if (node && entrance && !entered.current) {
      entered.current = true;
      animation.current = node.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 100 : 180,
        easing: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'cubic-bezier(0.4, 0, 0.2, 1)' : getComputedStyle(node).getPropertyValue('--ease-viewer').trim(),
      });
    }
  }, [entrance]);
  useEffect(() => () => animation.current?.cancel(), []);

  const close = (event) => {
    if (!(event?.detail > 0)) {
      onClose();
      return;
    }
    const opacity = getComputedStyle(target.current).opacity;
    animation.current?.cancel();
    animation.current = target.current.animate([{ opacity }, { opacity: 0 }], {
      duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 100 : 180,
      easing: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'cubic-bezier(0.4, 0, 0.2, 1)' : 'cubic-bezier(0.64, 0, 0.78, 0)',
      fill: 'forwards',
    });
    animation.current.finished.then(onClose, () => {});
  };
  return { ref, close };
}
